// extracted by mini-css-extract-plugin
export var buttonContent = "_43-0";
export var centered = "_43-1";
export var centeredFlex = "_43-2";
export var errorText = "_43-3";
export var icon = "_43-4";
export var iconButtonContent = "_43-5";
export var monospace = "_43-6";
export var padded = "_43-7";